import { render, staticRenderFns } from "./LandPageFooter.vue?vue&type=template&id=16cf6f2e&scoped=true"
import script from "./LandPageFooter.vue?vue&type=script&lang=js"
export * from "./LandPageFooter.vue?vue&type=script&lang=js"
import style0 from "./LandPageFooter.vue?vue&type=style&index=0&id=16cf6f2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cf6f2e",
  null
  
)

export default component.exports